import { Outlet, useNavigation, useLoaderData, useSubmit } from "react-router-dom";
import MainNavigation from "../components/MainNavigation";
import Footer from "../components/Footer";
import { useEffect } from "react";
import { getTokenDuration } from "../util/auth";
import { Container, Grid, Box } from "@mui/material";
import Welcome from "../components/Welcome";

function RootLayout() {
    const navigation = useNavigation();
    const token = useLoaderData();
    const submit = useSubmit();

    useEffect(() => {
        if (!token) {
            return;
        }

        if (token === 'EXPIRED') {
            submit(null, { action: '/logout', method: 'post' });
            return;
        }

        const tokenDuration = getTokenDuration();
        setTimeout(() => {
            submit(null, { action: '/logout', method: 'post' });
        }, tokenDuration)
    }, [token, submit]);

    /*
                <MainNavigation />
                <main>
                    <Grid container sx={{ padding: "20px" }} sc={{ mt: 3 }}>
                        <Grid container item xs={12} lg={3} sx={{ ml: { xs: 4, lg: 0 }}}>
                            <Welcome />
                        </Grid>
                        <Grid container item xs={12} lg={9} sx={{ textAlign: { xs: 'center', lg: 'left' }, mt: { xs: 1, lg: 0 }}} rowSpacing={0}>
                            {navigation.state === 'loading' && <p>Loading...</p>}
                            <Outlet />
                        </Grid>
                    </Grid>
                </main>
                <Footer />
                                <Grid
                    container
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={0}
                    direction="column"
                    display="flex">
                    <Outlet


                            <Grid container sx={{ flexGrow: 1, minHeight: '100vh' }} spacing={0} direction="column" alignItems="center" justifyContent="center" maxWidth="lg">
            <Grid item xs={3} lg={12} xl={12}>

            </Grid>
        </Grid>

    */
    //TODO 
    return <>
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            sx={{ bgcolor: "#D3D3D3" }}
        >
            <Container sx={{ flexGrow: 1, borderRadius: '5px', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)", bgcolor: "white", marginRight:'5px', marginLeft:'5px' }} maxWidth="sm">
                    <Grid container item spacing={2} sx={{ paddingBottom: '10px', paddingTop: '17px' }} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Outlet />
                    </Grid>
            </Container>
        </Box>
    </>
}

export default RootLayout;